import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/router'
import '@/app/globals.css'

// Cache-bust constant — bumped to force new chunk hashes when a prior
// deploy poisoned browser caches with immutable HTML responses. Safe to
// remove after 2027. Assigned to window so the minifier cannot dead-code
// eliminate it (a bare `void BUILD_TAG` gets stripped by esbuild).
;(window as unknown as { __BUILD_TAG__: string }).__BUILD_TAG__ = '2026-04-17-a';

// Recover from stale dynamic-import failures (e.g., after a Cloudflare Pages
// deploy race poisons a browser cache entry for a hashed chunk, or after a
// new deploy where the user's current index.html still references old chunk
// URLs). A full page reload fetches the no-cache index.html, which now points
// at current chunks. The sessionStorage guard prevents infinite reload loops
// if the chunk is genuinely unavailable — in that case we fall through to the
// existing error boundary.
const CHUNK_RELOAD_KEY = '__rfidwms_chunk_reload__';
window.addEventListener('vite:preloadError', (event) => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)

// Clear the reload guard once the app successfully mounts, so a later
// session-long chunk failure can still trigger a fresh recovery attempt.
sessionStorage.removeItem(CHUNK_RELOAD_KEY);
